import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight, TrendingUp, Eye } from 'lucide-react';
import PageNavbar from '@/layouts/PageNavbar/PageNavbar';
import BlogHeroSection from '@/components/custom/BlogHeroSection/BlogHeroSection';

function BlogPostsPage() {
  const [selectedCategory, setSelectedCategory] = useState('Todos');

  // Categorias disponíveis
  const categories = ['Todos', 'Inteligência Artificial', 'Segurança', 'Desenvolvimento', 'Notícias da Empresa'];

  // Dados dos posts do blog
  const blogPosts = [
    {
      id: 1,
      title: 'Como o ERP da Lukos Tecnologia pode transformar a gestão do seu posto?',
      excerpt: 'Com o ERP da Lukos, seu posto ganha eficiência, controle e competitividade. Consulte-nos.',
      author: 'Equipe LUKOS',
      date: '12 Jan 2026',
      category: 'Lukos',
      image: 'https://images.unsplash.com/photo-1602665742701-389671bc40c0?q=80&w=800&h=400&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      link: '#',
      trending: true,
      views: '4.8k',
    },
    {
      id: 2,
      title: 'Programa de Fidelidade Lukos para Postos de Gasolina',
      excerpt: 'Simples, Prático e 100% Gerenciado pelo WhatsApp. Na Lukos Tecnologia, entendemos a importância de oferecer soluções modernas e acessíveis.',
      author: 'Equipe LUKOS',
      date: '14 Jan 2026',
      category: 'Lukos',
      image: 'https://images.unsplash.com/photo-1521737852567-6949f3f9f2b5?q=80&w=1147&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      link: '#',
      trending: false,
      views: '3.2k',
    },
    {
      id: 3,
      title: 'Como a Inteligência Artificial Está Revolucionando a Gestão de Postos de Combustíveis',
      excerpt: 'A tecnologia está mudando a forma como diversos setores operam, e os postos de combustíveis não ficam de fora dessa.',
      author: 'Equipe LUKOS',
      date: '15 Jan 2026',
      category: 'Mercado',
      image: 'https://plus.unsplash.com/premium_photo-1683120963435-6f9355d4a776?q=80&w=663&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      link: '#',
      trending: true,
      views: '5.1k',
    },
    {
      id: 4,
      title: '5 Tópicos importantes sobre a Conciliação de Cartões – Lukos',
      excerpt: 'A conciliação de pagamentos é sempre um grande desafio para o lojista. É quase impossível realizar a conferência das taxas.',
      author: 'Equipe LUKOS',
      date: '16 Jan 2026',
      category: 'Lukos',
      image: 'https://images.pexels.com/photos/4472873/pexels-photo-4472873.jpeg',
      link: '#',
      trending: false,
      views: '2.9k',
    },
  ];

  // Filtrar posts por categoria
  const filteredPosts = selectedCategory === 'Todos'
    ? blogPosts
    : blogPosts.filter(post => post.category === selectedCategory);

  // Posts em destaque (trending)
  const featuredPosts = blogPosts.filter(post => post.trending);

  return (
    <div className="bg-white min-h-screen text-gray-900 relative">
      <PageNavbar transparent={true} />

      <div
        className="fixed inset-0 pointer-events-none z-0 opacity-40 mix-blend-multiply"
        style={{
          backgroundImage: 'radial-gradient(circle at 50% 50%, rgba(168, 85, 247, 0.05) 2px, transparent 2px)',
          backgroundSize: '30px 30px'
        }}
      />
      <div className="fixed top-0 right-0 w-[600px] h-[600px] bg-purple-200/30 blur-[120px] rounded-full mix-blend-multiply pointer-events-none"></div>
      <div className="fixed bottom-0 left-0 w-[500px] h-[500px] bg-indigo-200/30 blur-[100px] rounded-full mix-blend-multiply pointer-events-none"></div>

      {/* Hero Dedicado do Blog */}
      <BlogHeroSection />

      {/* Main Content */}
      <main className="relative z-10 pb-12">
        {/* Category Tabs */}
        <div className="mb-8 px-4 sm:px-6 lg:px-8 mt-4">
          <div className="container mx-auto max-w-7xl">
            <div className="flex gap-3 overflow-x-auto pb-2 scrollbar-hide">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-5 py-2 rounded-full text-sm font-semibold whitespace-nowrap transition-all ${selectedCategory === category
                    ? 'bg-[#8B5CF6] text-white shadow-[0_0_20px_rgba(139,92,246,0.3)]'
                    : 'bg-white text-gray-500 hover:text-purple-600 hover:bg-purple-50 border border-purple-100'
                    }`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Todos os Artigos Section */}
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="container mx-auto max-w-7xl">
            <div className="mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">Todos os Artigos</h2>
              <p className="text-gray-500 text-sm">Explore todo o nosso conteúdo</p>
            </div>

            {/* Full Grid of All Posts */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
              {filteredPosts.map((post) => (
                <div
                  key={post.id}
                  className="group relative bg-white border border-purple-100 hover:border-purple-300 rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-2 hover:shadow-xl hover:shadow-purple-100/50 flex flex-col h-full"
                >
                  {/* Image Container */}
                  <div className="relative h-72 overflow-hidden bg-gray-100">
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-30 z-10" />
                    <img
                      src={post.image}
                      alt={post.title}
                      className="w-full h-full object-contain object-center transition-transform duration-700 group-hover:scale-105 group-hover:brightness-105"
                      loading="lazy"
                      style={{ imageRendering: '-webkit-optimize-contrast' }}
                    />
                    <div className="absolute top-4 left-4 z-20">
                      <span className="px-3 py-1 rounded-full bg-white/90 backdrop-blur-md border border-purple-100 text-purple-700 text-xs font-bold uppercase tracking-wide shadow-sm">
                        {post.category}
                      </span>
                    </div>
                  </div>

                  <div className="p-6 flex-1 flex flex-col">
                    {/* Meta */}
                    <div className="flex items-center gap-3 text-purple-600 text-xs font-medium mb-3 uppercase tracking-wider">
                      <span>{post.date}</span>
                      <div className="w-1 h-1 rounded-full bg-purple-300" />
                      <span>{post.author}</span>
                    </div>

                    <Link to={post.link} className="block group-hover:no-underline">
                      <h3 className="text-xl font-bold text-gray-900 mb-3 leading-tight group-hover:text-purple-700 transition-colors">
                        {post.title}
                      </h3>
                    </Link>

                    <p className="text-gray-600 text-sm leading-relaxed mb-6 flex-1 line-clamp-3">
                      {post.excerpt}
                    </p>

                    <Link
                      to={post.link}
                      className="inline-flex items-center gap-2 text-purple-600 hover:text-purple-800 font-bold text-sm uppercase tracking-wide mt-auto group/link"
                    >
                      Ler artigo
                      <ChevronRight className="w-4 h-4 transform group-hover/link:translate-x-1 transition-transform" />
                    </Link>
                  </div>
                </div>
              ))}
            </div>

            {/* Pagination */}
            <div className="flex items-center justify-center gap-3 pb-12">
              <button
                className="flex items-center justify-center rounded-xl w-12 h-12 bg-white border border-purple-100 text-gray-400 hover:text-purple-700 hover:border-purple-300 hover:bg-purple-50 transition-all font-bold disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <ChevronLeft className="w-5 h-5" />
              </button>

              {[1, 2, 3].map((page) => (
                <button
                  key={page}
                  className={`flex items-center justify-center rounded-xl w-12 h-12 font-bold transition-all ${page === 1
                    ? 'bg-[#8B5CF6] text-white shadow-lg shadow-purple-500/30'
                    : 'bg-white border border-purple-100 text-gray-500 hover:text-purple-700 hover:border-purple-300 hover:bg-purple-50'
                    }`}
                >
                  {page}
                </button>
              ))}

              <button
                className="flex items-center justify-center rounded-xl w-12 h-12 bg-white border border-purple-100 text-gray-400 hover:text-purple-700 hover:border-purple-300 hover:bg-purple-50 transition-all font-bold"
              >
                <ChevronRight className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </main>

      {/* Custom Scrollbar Styles */}
      <style>{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>
  );
}

export default BlogPostsPage;
